// Marker colours for the ecosystem categories, in ONE place.
//
// The classic report and the Potensi reports each used to keep their own copy, and
// they drifted: "Residential & Apartemen" existed in one and not the other, and when
// "Kuliner" was added to the shared backend spec neither learned about it — so the
// densest category on the map rendered as anonymous grey. Both now import this, so a
// new category is coloured everywhere or nowhere.
//
// Keys must match place_context.ECOSYSTEM_SPEC + OSM_ECOSYSTEM_SPEC exactly.
//
// NOTE ON THE PALETTE'S LIMIT: with 16 categories every hue family on the wheel is
// already taken, so these are no longer all mutually distinguishable at a glance —
// Kuliner sits in the amber/olive range near Mall and Pasar. The legend is clickable
// and each marker carries a title, which is what actually separates them. Adding a
// 17th category should mean grouping some, not inventing another hue.
export const ECO_COLORS = {
  // Google Places categories
  "Kuliner":                 "#a16207",
  "Minimarket":              "#3b82f6",
  "Sekolah":                 "#8b5cf6",
  "Kampus":                  "#d946ef",
  "Hotel & Kost":            "#ec4899",
  "Office":                  "#0891b2",
  "Mall & Pusat":            "#f59e0b",
  "Pasar":                   "#65a30d",
  "Residential & Apartemen": "#6366f1",
  // OSM lattice layers (free) — added 2026-07
  "Rumah Sakit & Klinik":    "#dc2626",
  "Bank & ATM":              "#0d9488",
  "Transportasi":            "#7c3aed",
  "SPBU":                    "#ea580c",
  "Tempat Ibadah":           "#0284c7",
  "Taman":                   "#16a34a",
  "Gym & Olahraga":          "#db2777",
  // Local-advertiser groups (local_advertisers.GROUPS labels) — shown on the
  // Potensi Iklan map as categories of their own. Hues reuse the family above.
  "Sekolah & bimbel":                     "#8b5cf6",
  "Kampus & pendidikan tinggi":           "#d946ef",
  "Rumah sakit, klinik & apotek":         "#dc2626",
  "Perumahan, apartemen & developer":     "#6366f1",
  "Dealer, bengkel & SPBU":               "#ea580c",
  "Bank, asuransi & pembiayaan":          "#0d9488",
  "Mal, supermarket & ritel besar":       "#f59e0b",
  "Restoran & kafe":                      "#a16207",
  "Hotel & wisata":                       "#ec4899",
  "Salon, spa & kebugaran":               "#db2777",
  "Venue acara & komunitas":              "#0284c7",
};
